module.exports = __webpack_public_path__ + "img/credit-card-icon.0ae3c398.svg";